mutation CreateSmsDripSequenceEdition($input: SmsDripEditionCreateInput!) {
    smsDripEditionCreate(input: $input) {
        edition {
            id
            name
            isFirstEdition
            htmlUrl
            htmlUrlPath
            delay {
                unit
                timespan
            }
        }
    }
}
